import { WixPatternsContainer } from '../../state';
import { createContext } from '../createContext';

const { useContext, Provider, Context, Consumer } =
  createContext<WixPatternsContainer>('WixPatternsContainerProvider');

export const WixPatternsContainerProvider = Provider;
export const WixPatternsContainerConsumer = Consumer;
export const WixPatternsContainerContext = Context;
export const useWixPatternsContainer = useContext;
